export enum EPrimaryRole {
    NotMentioned = 0,
    Developer = 1,
    ProductManager = 2,
    Other = 3
}